import React from "react";
import { Link } from "react-router-dom";
import "./BenefitsSection.css";

const BenefitsSection = () => {
  return (
    <section className="benefits-section-main-wrapper-container">
      <div className="benefits-section-content-max-width-container">
        <div className="benefits-section-header-content-wrapper">
          <h2 className="benefits-section-main-title-heading">Pourquoi choisir Monagora ?</h2>
          <p className="benefits-section-subtitle-description-text">
            Des avantages concrets pour transformer votre activité
          </p>
        </div>
        
        <div className="benefits-section-benefits-grid-container">
          <div className="benefits-section-individual-benefit-card">
            <div className="benefits-section-benefit-icon-container">🤖</div>
            <h3 className="benefits-section-benefit-title-heading">Automatisez votre prise de rendez-vous</h3>
            <p className="benefits-section-benefit-description-text">
              Supprimez les tâches répétitives et laissez l'IA gérer vos plannings. 
              Vos clients reçoivent automatiquement des créneaux optimisés.
            </p>
            <div className="benefits-section-benefit-metric-container">
              <div className="benefits-section-benefit-metric-value-display">0 min</div>
              <div className="benefits-section-benefit-metric-label-text">travail manuel</div>
            </div>
            <ul className="benefits-section-benefit-features-list">
              <li className="benefits-section-benefit-feature-item">
                <span className="benefits-section-benefit-feature-text">Planification automatique</span>
              </li>
              <li className="benefits-section-benefit-feature-item">
                <span className="benefits-section-benefit-feature-text">Notifications clients</span>
              </li>
              <li className="benefits-section-benefit-feature-item">
                <span className="benefits-section-benefit-feature-text">Sync temps réel</span>
              </li>
            </ul>
          </div>
          
          <div className="benefits-section-individual-benefit-card">
            <div className="benefits-section-benefit-icon-container">⚡</div>
            <h3 className="benefits-section-benefit-title-heading">Optimisez grâce à l'intelligence artificielle</h3>
            <p className="benefits-section-benefit-description-text">
              Notre IA analyse vos habitudes et contraintes pour proposer 
              les créneaux les plus pertinents et efficaces.
            </p>
            <div className="benefits-section-benefit-metric-container">
              <div className="benefits-section-benefit-metric-value-display">+200%</div>
              <div className="benefits-section-benefit-metric-label-text">efficacité</div>
            </div>
            <ul className="benefits-section-benefit-features-list">
              <li className="benefits-section-benefit-feature-item">
                <span className="benefits-section-benefit-feature-text">Analyse prédictive</span>
              </li>
              <li className="benefits-section-benefit-feature-item">
                <span className="benefits-section-benefit-feature-text">Optimisation géographique</span>
              </li>
              <li className="benefits-section-benefit-feature-item">
                <span className="benefits-section-benefit-feature-text">Apprentissage automatique</span>
              </li>
            </ul>
          </div>
          
          <div className="benefits-section-individual-benefit-card">
            <div className="benefits-section-benefit-icon-container">💰</div>
            <h3 className="benefits-section-benefit-title-heading">Économisez sur vos charges d'exploitation</h3>
            <p className="benefits-section-benefit-description-text">
              Réduisez drastiquement vos coûts de déplacement grâce à 
              l'optimisation géographique intelligente.
            </p>
            <div className="benefits-section-benefit-metric-container">
              <div className="benefits-section-benefit-metric-value-display">15K€+</div>
              <div className="benefits-section-benefit-metric-label-text">économisés/an</div>
            </div>
            <ul className="benefits-section-benefit-features-list">
              <li className="benefits-section-benefit-feature-item">
                <span className="benefits-section-benefit-feature-text">Optimisation trajets</span>
              </li>
              <li className="benefits-section-benefit-feature-item">
                <span className="benefits-section-benefit-feature-text">Réduction carburant</span>
              </li>
              <li className="benefits-section-benefit-feature-item">
                <span className="benefits-section-benefit-feature-text">Gain temps précieux</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection; 